import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "ui";

import { merchantPriceValidationSchema } from "../../../helpers";
import {
  MerchantPriceFormProps,
  MerchantPriceFormValues
} from "./MerchantPriceForm.types";

import styles from "./MerchantPriceForm.module.scss";

const MerchantPriceForm = ({
  formId,
  defaultMerchantPrice,
  onSubmit
}: MerchantPriceFormProps) => {
  const { t } = useTranslation();
  const { control, handleSubmit } = useForm<MerchantPriceFormValues>({
    defaultValues: {
      value: defaultMerchantPrice
    },
    resolver: yupResolver(merchantPriceValidationSchema)
  });

  return (
    <form id={formId} className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <p className={styles.form_title}>{t("Min Merchant Price")} (FCFA)</p>
      <Controller
        control={control}
        name="value"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            type="number"
            value={value}
            onChange={onChange}
            errorMessage={error?.message}
          />
        )}
      />
    </form>
  );
};

export default MerchantPriceForm;
